import * as React from 'react';
import { Dispatch } from 'redux';
import { UserViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as UserNormalizers from '../normalizers/userNormalizers';

export class GetAllUsersRequest extends BaseApiGetRequest<
  UserViewModel,
  EntityNormalizers.NormalizedEntityArray<UserNormalizers.NormalizedUsers>
> {
  constructor(component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/users`;
    this.normalizeMethod = UserNormalizers.normalizeUsers;
  }
}
